<template>
  <div class="content">
    <BlockUI
      v-if="blockScreen"
      :url="blockScreenData.url"
      :message="blockScreenData.msg"
    />

    <v-card>
      <v-card-title
        style="background-color: var(--secondary-color); padding: 10px"
      >
        <label style="color: white; font-weight: 600; font-size: 25px">
          Reservas em andamento
        </label>
      </v-card-title>
      <v-card-subtitle>
        <v-flex class="mt-2">
          <v-row justify="space-between">
            <v-flex xs12 md6 sm6>
              <v-col align="start">
                <v-text-field
                  v-model="search"
                  prepend-icon="search"
                  label="Procurar"
                  single-line
                  hide-details
                />
              </v-col>
            </v-flex>
          </v-row>
        </v-flex>
      </v-card-subtitle>

      <v-divider />

      <v-card-text>
        <v-data-table
          :footer-props="{
            'items-per-page-text': 'Linhas por página:',
          }"
          :headers="headers"
          :items="data"
          :search="search"
          no-data-text="Sem reservas em andamento"
          class="elevation-1 mt-2"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.id }}</td>
              <td>{{ item.step.title }}</td>
              <td>{{ item.created_date | formatDate }}</td>
              <td>{{ item.begin_date | formatDate }}</td>
              <td>{{ item.begin_date_real | formatDate }}</td>
              <td>{{ item.end_date | formatDate }}</td>
              <td>
                {{
                  `${item.vehicle.vehicle_model.model} - ${item.vehicle.plate} `
                }}
              </td>
              <td>{{ item.user.name }}</td>
              <td>
                {{ item.client.name }}
              </td>
              <td>{{ item.reservation_value | formatValue }}</td>
              <td>{{ item.promotion === null ? '' : item.promotion.name }}</td>
              <td>
                <ActionButton
                  message="Detalhes da reserva"
                  icon="open_in_new"
                  color="info"
                  @onclick="detail(item)"
                />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from '../../helpers/BlockScreenUi';
import ActionButton from '../shared/ActionButtonsTemplate';
import moment from 'moment';
import VehicleRequestController from '../../controllers/VehicleRequestController';
import Constants from '../../models/constants/Constants';

export default {
  components: {
    ActionButton,
  },
  async created() {
    await this.getAllReservationsInProgress();
  },
  data() {
    return {
      search: '',
      vehicleRequestController: new VehicleRequestController(this.$resource),
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Status', value: 'step.title' },
        { text: 'Data criação', value: 'created_date' },
        { text: 'Checkin previsto', value: 'begin_date' },
        { text: 'Checkin real', value: 'begin_date_real' },
        { text: 'Checkout previsto', value: 'end_date' },
        {
          text: 'Veículo',
          value: 'vehicle.vehicle_model.model' + 'vehicle.plate',
        },
        { text: 'Usuário', value: 'user.name' },
        { text: 'Cliente', value: 'client.name' },
        { text: 'Valor da reserva', value: 'reservation_value' },
        { text: 'Promoção', value: 'promotion' },
      ],
      data: [],
      showModal: false,
      url_bucket: Constants.URL_BUCKET_PICKNDRIVE,
      url: null,
    };
  },
  methods: {
    async getAllReservationsInProgress() {
      try {
        this.blockScreen = true;
        const response = await this.vehicleRequestController.getReservationsInProgress();
        this.data = response;
      } catch (error) {
        this.$awn.alert(error.message);
      } finally {
        this.blockScreen = false;
      }
    },

    detail(item) {
      let routeData = this.$router.resolve({
        name: 'tcs-vehicle-request-detail',
        params: {
          id: item.id,
        },
      });
      window.open(routeData.href, '_blank');
      localStorage.setItem('pageBack', Constants.ROUTER_NAME_SERVICE);
    },
  },
  filters: {
    formatDate(value) {
      moment.locale('pt-Br');
      return value ? moment(value).format('DD/MM/YYYY HH:mm') : '';
    },

    formatValue(value) {
      let valueFloat = parseFloat(value / 100);
      let formatedValue = 'R$ ' + valueFloat.toFixed(2).replace('.', ',');
      return formatedValue;
    },
  },
};
</script>
<style>
.table-custom-vue {
  margin: 25px;
}
.table-custom-vue td:last-child {
  display: flex;
  justify-content: center;
}
</style>
